import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  jurisdictionNumbers: [],
  jurisdictionNumbersMap: {}
};

export const jurisdictionNumbersSlice = createSlice({
  name: 'jurisdictionNumbers',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setJurisdictionNumbers: (state, action) => {
      // const jurisdictionNumbers = action.payload || [];
      // state.jurisdictionNumbers = jurisdictionNumbers;
      // state.jurisdictionNumbersMap = jurisdictionNumbers.reduce((acc, curr) => {
      //   acc[curr.equipmentId] = curr;
      //   return acc;
      // }, {});

      const { jurisdictionNumbers, jurisdictionNumbersMap } = action.payload;
      state.jurisdictionNumbers = jurisdictionNumbers;
      state.jurisdictionNumbersMap = jurisdictionNumbersMap;
    },

    deleteJurisdictionNumbers: (state, action) => {
      const jurisdictionId = action.payload || [];
      let copyJurisdictionNumbers = [...(state.jurisdictionNumbers || [])];
      copyJurisdictionNumbers = copyJurisdictionNumbers?.filter(
        (x) => x?.jurisdiction !== jurisdictionId
      );

      state.jurisdictionNumbers = copyJurisdictionNumbers;
    },

    updateEquipmentJurisdictionNumbers: (state, action) => {
      const { jurisdictionNumbers, jurisdictionNumbersMap } = action.payload;
      // console.log('Hello world!', jurisdictionNumbers, jurisdictionNumbersMap);
      state.jurisdictionNumbers = jurisdictionNumbers;
      state.jurisdictionNumbersMap = jurisdictionNumbersMap;
    },

    setJurisdictionNumbers1: (state, action) => {
      state.jurisdictionNumbers = [...state.jurisdictionNumbers, ...action.payload];
    }
  }
});

const jurisdictionNumbersReducer = jurisdictionNumbersSlice.reducer;
export const jurisdictionNumbersActions = jurisdictionNumbersSlice.actions;
export default jurisdictionNumbersReducer;
